import { render, staticRenderFns } from "./WorkflowAttributes.vue?vue&type=template&id=4ebc9082"
import script from "./WorkflowAttributes.vue?vue&type=script&lang=js"
export * from "./WorkflowAttributes.vue?vue&type=script&lang=js"
import style0 from "./WorkflowAttributes.vue?vue&type=style&index=0&id=4ebc9082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports